import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
// import { MatMenu } from '@angular/material';
export interface Publication {
  publicationId: number;
  status: string;
  startDate: string;
  endDate: string;
  secondarySourceName: string;
  sourceName: string;
  linkedSource: number;
  hotJob: boolean;
  hotJobDays: string;
  remarks: string;
  checked?: boolean;
}
export interface PostingApprovals2 {
  requisitionId: number;
  recruiterId: string;
  requestName: string;
  recruiter: string;
  numberOfPositions: number;
  checked?: boolean;
  pu: string;
  role: string;
  publication: Publication[];
  unitCode?: string;
}

@Component({
  selector: 'app-filter-menu',
  templateUrl: './filter-menu.component.html',
  styleUrls: ['./filter-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FilterMenuComponent implements OnChanges {
  locationDisplay = [];
  reqIdDisplay = []; //dynamic variable changes with keyword typed
  reqTitleDisplay = []; //dynamic variable changes with keyword typed
  reqTitleDisplayList = []; //list for storing all titles
  reqIdDisplayList = []; //list for storing all reqIds
  keyword = new UntypedFormControl(); //keyword for typed req id in filter by
  keyword_title = new UntypedFormControl(); // keyword for typed req title in filter by
  filteredRequisitionId = []; //filtered out req ids[ticked options]
  filteredRequisitionTitle = []; //filtered out req titles[ticked options]
  roleDisplay = [];
  dueDateDisplay = [];
  puDisplay = [];
  requisitionIdDisplay = [];
  sourceDisplay = [];
  recruiterDisplay = [];
  recruiterDisplayList = [];
  createdByDisplay = [];
  skillDisplay = ['Java', 'Angular', 'HTML'];
  filteredLocation = [];
  filteredRole = [];
  filteredSkill = [];
  filteredDueDate = [];
  filteredPU = [];
  filteredReqId = [];
  filteredCreatedBy = [];
  filteredSource = [];
  filteredRecruiter = [];
  // @ViewChild(MatMenu, {static: false}) menu: MatMenu;
  @Input() dataSource = [];
  @Input() recLead: boolean;
  dataSourceModified = [];
  @Input() selected;
  @Output() applyChange = new EventEmitter();
  dataSourceModified2: PostingApprovals2;

  //Filter values input output to rec lead screen
  @Input() recLeadFilters_IN: any;
  @Output() recLeadFilters_OUT = new EventEmitter();
  id = localStorage.getItem('fresherCompHiringTypeId');

  constructor() {}
  ngOnChanges() {
    //console.log(this.selected)
    //console.log(this.dataSource)
    this.clearFilter();
    this.locationDisplay = [];
    this.reqIdDisplay = [];
    this.reqIdDisplayList = [];
    this.reqTitleDisplay = [];
    this.reqTitleDisplayList = [];
    this.roleDisplay = [];
    this.dueDateDisplay = [];
    this.puDisplay = [];
    this.requisitionIdDisplay = [];
    this.createdByDisplay = [];
    this.skillDisplay = [];
    this.sourceDisplay = [];
    this.recruiterDisplay = [];
    this.recruiterDisplayList = [];
    if (this.recLead) {
      //console.log("!!! ngOnchanges", this.recLeadFilters_IN);

      if (this.recLeadFilters_IN && Object.keys(this.recLeadFilters_IN).length > 0) {
        this.filteredReqId = this.recLeadFilters_IN.filteredReqId ? this.recLeadFilters_IN.filteredReqId : [];
        this.filteredPU = this.recLeadFilters_IN.filteredPU ? this.recLeadFilters_IN.filteredPU : [];
        this.filteredRecruiter = this.recLeadFilters_IN.filteredRecruiter
          ? this.recLeadFilters_IN.filteredRecruiter
          : [];
        this.filteredRole = this.recLeadFilters_IN.filteredRole ? this.recLeadFilters_IN.filteredRole : [];
        this.filteredSource = this.recLeadFilters_IN.filteredSource ? this.recLeadFilters_IN.filteredSource : [];
      }
      this.dataSource.forEach((element1) => {
        element1.publication.forEach((item) => {
          // console.log("element----",item)

          //For recruiter        //Re populating the list object depending on typed keyword otherwise population complete data(requisitionId list)

          if (this.recruiterDisplay.indexOf(element1['recruiterId']) === -1) {
            if (
              this.keyword.value == null ||
              element1['recruiterId'].toString().toLowerCase().startsWith(this.keyword.value.toLowerCase())
            ) {
              if (element1['recruiterId'] != null) {
                this.recruiterDisplay.push(element1['recruiterId']);
              }
            }
            this.recruiterDisplayList.push(element1['recruiterId']);
          }
          //console.log(this.recruiterDisplayList)

          //For PU

          if (this.requisitionIdDisplay.indexOf(element1['requisitionId']) === -1) {
            this.requisitionIdDisplay.push(element1['requisitionId']);
          }
          if (this.puDisplay.indexOf(element1['pu']) === -1) {
            this.puDisplay.push(element1['pu']);
          }
          if (this.roleDisplay.indexOf(element1.role) === -1) {
            this.roleDisplay.push(element1.role);
          }
          if (this.sourceDisplay.indexOf(item['sourceName']) === -1) {
            this.sourceDisplay.push(item['sourceName']);
          }
        });
      });
    } else {
      this.dataSource.forEach((element) => {
        if (this.selected === 'location' || this.selected == 'S2H' || this.selected == 'S2RL') {
          if ('Skills' in element) {
            if (this.skillDisplay.indexOf(element.Skills) === -1) {
              this.skillDisplay.push(element.Skills);
            }
          }
        }
        if (this.selected === 'skill' || this.selected == 'S2H' || this.selected == 'S2RL') {
          if ('Location' in element) {
            if (this.locationDisplay.indexOf(element.Location) === -1) {
              this.locationDisplay.push(element.Location);
            }
          }
        }
        //For req Id
        //Re populating the list object depending on typed keyword otherwise population complete data(requisitionId list)
        if (this.reqIdDisplay.indexOf(element['Req Id']) === -1) {
          if (
            this.keyword.value == null ||
            element['Req Id'].toString().toLowerCase().startsWith(this.keyword.value.toLowerCase())
          ) {
            this.reqIdDisplay.push(element['Req Id']);
          }
          this.reqIdDisplayList.push(element['Req Id']);
        }
        //For req title
        //Re populating the list object depending on typed keyword otherwise population complete data(requisitionId list)
        //console.log("!!!",element);

        if (this.reqTitleDisplay.indexOf(element['Requisition Title']) === -1) {
          if (
            this.keyword_title.value == null ||
            element['Requisition Title'].toString().toLowerCase().startsWith(this.keyword_title.value.toLowerCase())
          ) {
            this.reqTitleDisplay.push(element['Requisition Title']);
          }
          this.reqTitleDisplayList.push(element['Requisition Title']);
        }
        if (this.roleDisplay.indexOf(element.Role) === -1) {
          this.roleDisplay.push(element.Role);
        }
        if (this.dueDateDisplay.indexOf(element['Due by']) === -1) {
          this.dueDateDisplay.push(element['Due by']);
        }
        if (this.requisitionIdDisplay.indexOf(element['requisitionId']) === -1) {
          this.requisitionIdDisplay.push(element['requisitionId']);
        }
        if (this.puDisplay.indexOf(element['PU']) === -1) {
          this.puDisplay.push(element['PU']);
        }
        if (this.createdByDisplay.indexOf(element['Created By']) === -1) {
          this.createdByDisplay.push(element['Created By']);
        }
      });
    }
    this.sourceDisplay.sort();
    this.roleDisplay.sort();
    this.recruiterDisplay.sort();
    this.puDisplay.sort();
  }

  emitFilterValues() {
    const recLeadFilterObj = {
      filteredReqId: this.filteredReqId,
      filteredPU: this.filteredPU,
      filteredRecruiter: this.filteredRecruiter,
      filteredRole: this.filteredRole,
      filteredSource: this.filteredSource,
    };
    //console.log("!!! object emitted", recLeadFilterObj);

    this.recLeadFilters_OUT.emit(recLeadFilterObj);
  }
  applyFilter() {
    this.keyword_title.reset();
    this.keyword.reset();
    this.dataSourceModified = [];

    if (this.recLead) {
      this.emitFilterValues();
      console.log('!!! data s', this.dataSource);

      this.dataSource.forEach((element) => {
        const dataModified2: PostingApprovals2 = {
          requisitionId: null,
          recruiterId: null,
          requestName: null,
          recruiter: null,
          numberOfPositions: null,
          checked: null,
          pu: null,
          role: null,
          publication: [],
          unitCode: null,
        };
        let recLeadDataSource: Publication[] = [];
        //console.log(element)
        let recruiterMatch = false;
        let roleMatch = false;
        let puMatch = false;
        let reqIdMatch = false;

        let sourceMatch = false;
        if (this.filteredRecruiter.length === 0) {
          recruiterMatch = true;
        } else {
          if ('recruiter' in element) {
            for (let i = 0; i < this.filteredRecruiter.length; i++) {
              if (element['recruiterId'] === this.filteredRecruiter[i]) {
                recruiterMatch = true;
                break;
              }
            }
          }
        }

        if (this.filteredPU.length === 0) {
          puMatch = true;
        } else {
          for (let i = 0; i < this.filteredPU.length; i++) {
            if (element['pu'] === this.filteredPU[i]) {
              puMatch = true;
              break;
            }
          }
        }
        if (this.filteredReqId.length === 0) {
          reqIdMatch = true;
        } else {
          for (let i = 0; i < this.filteredReqId.length; i++) {
            if (element['requisitionId'] === this.filteredReqId[i]) {
              reqIdMatch = true;
              break;
            }
          }
        }

        if (this.filteredRole.length === 0) {
          roleMatch = true;
        } else {
          for (let i = 0; i < this.filteredRole.length; i++) {
            if (element.role === this.filteredRole[i]) {
              roleMatch = true;
              break;
            }
          }
        }
        if (this.filteredSource.length === 0) {
          sourceMatch = true;
        } else {
          const _index = 0;
          recLeadDataSource = [];
          element.publication.forEach((element1) => {
            for (let i = 0; i < this.filteredSource.length; i++) {
              if (element1['sourceName'] === this.filteredSource[i]) {
                sourceMatch = true;
                recLeadDataSource.push(element1);
                break;
              }
            }
          });
          if (recLeadDataSource.length > 0) {
            dataModified2.publication = recLeadDataSource;
            dataModified2.pu = element.pu;
            dataModified2.numberOfPositions = element.numberOfPositions;
            dataModified2.recruiter = element.recruiter;
            dataModified2.recruiterId = element.recruiterId;
            dataModified2.requestName = element.requestName;
            dataModified2.requisitionId = element.requisitionId;
            dataModified2.role = element.role;
            dataModified2.unitCode = element.unitCode;
          }
        }

        if (roleMatch && recruiterMatch && puMatch && sourceMatch && reqIdMatch) {
          console.log('@', element);
          if (recLeadDataSource.length > 0) {
            this.dataSourceModified.push(dataModified2);
          } else {
            this.dataSourceModified.push(element);
          }
        }

        // if(this.dataSourceModified.length >0)
        // {
        // this.dataSourceModified2.push(this.recLeadDataSource);
        // }
        // console.log(this.dataSourceModified2)
      });
      this.applyChange.emit(this.dataSourceModified);
    } else {
      this.dataSource.forEach((element) => {
        let reqIdMatch = false;
        let reqTitleMatch = false;
        let locationMatch = false;
        let roleMatch = false;
        let dueDateMatch = false;
        let puMatch = false;
        let createdByMatch = false;
        let skillMatch = false;

        if (this.filteredRequisitionId.length === 0) {
          reqIdMatch = true;
        } else {
          if ('Req Id' in element) {
            for (let i = 0; i < this.filteredRequisitionId.length; i++) {
              if (element['Req Id'] === this.filteredRequisitionId[i]) {
                reqIdMatch = true;
                break;
              }
            }
          }
        }
        if (this.filteredRequisitionTitle.length === 0) {
          reqTitleMatch = true;
        } else {
          if ('Requisition Title' in element) {
            for (let i = 0; i < this.filteredRequisitionTitle.length; i++) {
              if (element['Requisition Title'] === this.filteredRequisitionTitle[i]) {
                reqTitleMatch = true;
                break;
              }
            }
          }
        }
        if (this.filteredLocation.length === 0) {
          locationMatch = true;
        } else {
          if (this.selected === 'skill' || this.selected == 'S2H' || this.selected == 'S2RL') {
            if ('Location' in element) {
              for (let i = 0; i < this.filteredLocation.length; i++) {
                if (element.Location === this.filteredLocation[i]) {
                  locationMatch = true;
                  break;
                }
              }
            }
          }
        }
        if (this.filteredSkill.length === 0) {
          skillMatch = true;
        } else {
          if (this.selected === 'location' || this.selected == 'S2H' || this.selected == 'S2RL') {
            if ('Skills' in element) {
              for (let i = 0; i < this.filteredSkill.length; i++) {
                if (element.Skills === this.filteredSkill[i]) {
                  skillMatch = true;
                  break;
                }
              }
            }
          }
        }
        if (this.filteredRole.length === 0) {
          roleMatch = true;
        } else {
          for (let i = 0; i < this.filteredRole.length; i++) {
            if (element.Role === this.filteredRole[i]) {
              roleMatch = true;
              break;
            }
          }
        }
        if (this.filteredDueDate.length === 0) {
          dueDateMatch = true;
        } else {
          for (let i = 0; i < this.filteredDueDate.length; i++) {
            if (element['Due by'] === this.filteredDueDate[i]) {
              dueDateMatch = true;
              break;
            }
          }
        }
        if (this.filteredPU.length === 0) {
          puMatch = true;
        } else {
          for (let i = 0; i < this.filteredPU.length; i++) {
            if (element['PU'] === this.filteredPU[i]) {
              puMatch = true;
              break;
            }
          }
        }
        if (this.filteredCreatedBy.length === 0) {
          createdByMatch = true;
        } else {
          for (let i = 0; i < this.filteredCreatedBy.length; i++) {
            if (element['Created By'] === this.filteredCreatedBy[i]) {
              createdByMatch = true;
              break;
            }
          }
        }
        if (
          locationMatch &&
          skillMatch &&
          roleMatch &&
          dueDateMatch &&
          reqIdMatch &&
          reqTitleMatch &&
          puMatch &&
          createdByMatch
        ) {
          this.dataSourceModified.push(element);
        }
      });
      //console.log('Modified Data', this.dataSourceModified)
      this.applyChange.emit(this.dataSourceModified);
    }
  }
  checkLocation(location) {
    if (this.filteredLocation.indexOf(location) === -1) {
      this.filteredLocation.push(location);
    } else {
      this.filteredLocation.splice(this.filteredLocation.indexOf(location), 1);
    }
    //console.log(this.filteredLocation)
  }
  checkRole(role) {
    if (this.filteredRole.indexOf(role) === -1) {
      this.filteredRole.push(role);
    } else {
      this.filteredRole.splice(this.filteredRole.indexOf(role), 1);
    }
    //console.log(this.filteredRole)
  }
  checkSkill(skill) {
    if (this.filteredSkill.indexOf(skill) === -1) {
      this.filteredSkill.push(skill);
    } else {
      this.filteredSkill.splice(this.filteredRole.indexOf(skill), 1);
    }
    //console.log(this.filteredSkill)
  }
  checkDueDate(dueBy) {
    if (this.filteredDueDate.indexOf(dueBy) === -1) {
      this.filteredDueDate.push(dueBy);
    } else {
      this.filteredDueDate.splice(this.filteredDueDate.indexOf(dueBy), 1);
    }
  }
  checkSource(source) {
    if (this.filteredSource.indexOf(source) === -1) {
      this.filteredSource.push(source);
    } else {
      this.filteredSource.splice(this.filteredSource.indexOf(source), 1);
    }
    console.log(this.filteredSource);
  }
  checkReqId1(pu) {
    if (this.filteredReqId.indexOf(pu) === -1) {
      this.filteredReqId.push(pu);
    } else {
      this.filteredReqId.splice(this.filteredReqId.indexOf(pu), 1);
    }
  }
  checkPU(pu) {
    if (this.filteredPU.indexOf(pu) === -1) {
      this.filteredPU.push(pu);
    } else {
      this.filteredPU.splice(this.filteredPU.indexOf(pu), 1);
    }
  }
  checkCreatedBy(createdBy) {
    if (this.filteredCreatedBy.indexOf(createdBy) === -1) {
      this.filteredCreatedBy.push(createdBy);
    } else {
      this.filteredCreatedBy.splice(this.filteredCreatedBy.indexOf(createdBy), 1);
    }
  }
  //clearing all filtered objects when clicked on clear all in filter by dropdown
  clearFilter() {
    this.filteredRequisitionId = [];
    this.filteredRequisitionTitle = [];
    this.filteredLocation = [];
    this.filteredRole = [];
    this.filteredSkill = [];
    this.filteredDueDate = [];
    this.filteredReqId = [];
    this.filteredPU = [];
    this.filteredCreatedBy = [];
    this.filteredRecruiter = [];
    this.filteredSource = [];
    this.keyword_title.reset();
    this.keyword.reset();
  }
  //Tick-untick function of requisition ID in filter by dropdown
  checkReqId(reqId) {
    if (this.filteredRequisitionId.indexOf(reqId) === -1) {
      this.filteredRequisitionId.push(reqId);
    } else {
      this.filteredRequisitionId.splice(this.filteredRequisitionId.indexOf(reqId), 1);
    }
    console.log(this.filteredRequisitionId);
  }
  checkRecruiterId(recId) {
    if (this.filteredRecruiter.indexOf(recId) === -1) {
      this.filteredRecruiter.push(recId);
    } else {
      this.filteredRecruiter.splice(this.filteredRecruiter.indexOf(recId), 1);
    }
    console.log(this.filteredRecruiter);
  }
  //Tick-untick function of requisition title in filter by dropdown
  checkReqTitle(reqTitle) {
    if (this.filteredRequisitionTitle.indexOf(reqTitle) === -1) {
      this.filteredRequisitionTitle.push(reqTitle);
    } else {
      this.filteredRequisitionTitle.splice(this.filteredRequisitionTitle.indexOf(reqTitle), 1);
    }
  }

  //Filter out the list of requisition ID on the basis of typed keyword in filter by dropdown
  searchReqId() {
    //console.log("!!!ABC searched typed",this.keyword.value);
    this.reqIdDisplay = [];
    this.reqIdDisplayList.forEach((value) => {
      if (this.keyword && value.toString().toLowerCase().startsWith(this.keyword.value.toLowerCase())) {
        this.reqIdDisplay.push(value);
      }
    });
  }
  searchRecruiterId() {
    //console.log("!!!ABC searched typed",this.keyword.value);
    this.recruiterDisplay = [];
    this.recruiterDisplayList.forEach((value) => {
      if (this.keyword && value.toString().toLowerCase().startsWith(this.keyword.value.toLowerCase())) {
        this.recruiterDisplay.push(value);
      }
    });
  }
  //Filter out the list of requisition titles on the basis of typed keyword in filter by dropdown
  searchReqTitle() {
    this.reqTitleDisplay = [];
    this.reqTitleDisplayList.forEach((value) => {
      if (this.keyword_title && value.toString().toLowerCase().startsWith(this.keyword_title.value.toLowerCase())) {
        this.reqTitleDisplay.push(value);
      }
    });
  }
}
